export const LOCALE_FORMATTERS = {
  CURRENCY: 'currency',
  CURRENCY_CUSTOM: 'currency-custom',
  DATE_LONG: 'date-long',
  DATE_MONTH_YEAR: 'date-month-year',
  DATE_YEARLESS: 'date-yearless',
  VOWEL_ENDING: 'vowel-ending',
} as const;

export const isLocaleFormat = (
  format: string,
): format is (typeof LOCALE_FORMATTERS)[keyof typeof LOCALE_FORMATTERS] => {
  return Object.values(LOCALE_FORMATTERS).includes(format as never);
};
